import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Spinner from './../../reusable/Spinner/Spinner';
import TableHeader from './Components/TableHeader';
import TableRow from './Components/TableRow';

class TableGrid extends Component {
    static propTypes = {
        headerItems: PropTypes.array,
        listItems: PropTypes.array,
        noEntries: PropTypes.func,
        className: PropTypes.string
    };

    static defaultProps = {
        headerItems: null,
        listItems: null,
        className: "",
        noEntries: () => (
            <div className="rmm-no-entries">
                <FormattedMessage id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
            </div>
        )
    };

    render() {
        if (this.props.listItems && this.props.listItems.length === 0) {
            return this.props.noEntries();
        } else {
            const rows = this.props.listItems && this.props.listItems.map((item, index) =>
                <TableRow headerItems={this.props.headerItems} item={item} key={index}/>)

            return (
                <div className={"table-grid-view " + this.props.className}>
                    { this.props.listItems === null ? <Spinner isLoading /> : rows}
                </div>
            )
        }
    }
}

export default TableGrid;


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/TableGrid.jsx